<template>
  <v-container fill-height class="d-flex justify-center">
    <v-row v-if="hasCurrentUser && !isCurrentUserCompleted">
      <v-col>
        <v-alert
          type="info"
          colored-border
          color="primary lighten-2"
          elevation="2"
          border="left"
        >
          {{ $t('profile.hints.incomplete_profile') }}
          <v-btn
            text
            color="primary"
            :to='{name: "editProfile"}'
          >
            {{ $t('commons.next') }}
          </v-btn>
        </v-alert>
      </v-col>
    </v-row>

    <OrdersListCards
      v-if="orders.length > 0"
      :orders="orders"
    />

    <h3 v-else-if="orders.length === 0 && !loading" class="d-flex justify-center subtitle">
      {{ $t('order.list.none') }}
    </h3>

    <v-card
      v-else
      elevation="0"
      class="mb-12"
    >
      <v-progress-circular
        color="primary"
        size="50"
        indeterminate
      />
    </v-card>
  </v-container>
</template>

<script>
  import OrdersListCards from '../orders/orders_list_cards'
  import { currentUserMixin } from '../../mixins/current_user_mixin'
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      OrdersListCards,
    },
    mixins: [
      currentUserMixin,
    ],
    created() {
      this.fetchOrders('ALL')
    },
    computed: {
      ...mapState('order', ['orders']),
      ...mapState('layout', ['loading']),
      ...mapGetters('profile', [
        'currentUser',
        'hasCurrentUser'
      ]),
    },
    methods: {
      ...mapActions('order', ['fetchOrders'])
    },
  }
</script>
